import { useCallback, useEffect, useState } from "react";
import ProductsAPI from "../../services/ProductsAPI";

export default function DashBoardButton() {
  const [hover, setHover] = useState(false);
  const [dashBoardLink, setDashBoardLink] = useState(null);

  useEffect(() => {
    ProductsAPI.getCustomerDashBoard().then((response) =>
      setDashBoardLink(response.dashboard)
    );
  }, []);

  const handleMouseIn = useCallback(() => {
    setHover(true);
  }, []);

  const handleMouseOut = useCallback(() => {
    setHover(false);
  }, []);

  const handleOpenDash = useCallback(() => {
    window.location.assign("/dashboard");
  }, []);

  return (
    <button
      style={{
        padding: "0px 15px",
        textAlign: "center",
        textDecoration: "none",
        color: hover ? "#ffffff" : "#b83e00",
        backgroundColor: hover ? "#b83e0080" : "#b83e0035",
        margin: 15,
        border: "none",
        borderRadius: 5,
        display: dashBoardLink ? "flex" : "none",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        transition: "0.5s",
        cursor: "pointer",
      }}
      onClick={handleOpenDash}
      onMouseEnter={handleMouseIn}
      onMouseLeave={handleMouseOut}
    >
      <p style={{ fontSize: "1rem" }}>Painel de Consolidados</p>
      <p style={{ width: 20, height: 20 }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0-201.4 201.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 80c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 96z"
          />
        </svg>
      </p>
    </button>
  );
}
